import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface FoodCategory {
    id: string;
    name: string;
    points: number;
    maxUses?: number;
    // Deliberately unwired — see the note on Category in schema.prisma
    isRepeatable: boolean;
    createdAt: string;
    updatedAt: string;
}

// API functions
export const fetchFoodCategories = async (): Promise<FoodCategory[]> => {
    const response = await api.get<FoodCategory[]>('/categories');
    return response.data;
};

// React Query hooks
export const useFoodCategories = () => {
    return useQuery({
        queryKey: ['food-categories'],
        queryFn: fetchFoodCategories,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
    });
};
